import { render, staticRenderFns } from "./TopScroll.vue?vue&type=template&id=3704f412&scoped=true&"
import script from "./TopScroll.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TopScroll.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TopScroll.vue?vue&type=style&index=0&id=3704f412&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3704f412",
  null
  
)

export default component.exports